// Push notification service for reminders
export class NotificationService {
  static async requestPermission() {
    if (!('Notification' in window)) {
      console.warn('Notifications not supported');
      return false;
    }

    if (Notification.permission === 'granted') {
      return true;
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }

    return false;
  }

  static async scheduleNotification(title, body, delay = 0) {
    const hasPermission = await this.requestPermission();
    
    if (!hasPermission) {
      console.warn('Notification permission denied');
      return;
    }

    if (delay > 0) {
      setTimeout(() => {
        this.showNotification(title, body);
      }, delay);
    } else {
      this.showNotification(title, body);
    }
  }

  static showNotification(title, body, options = {}) {
    if (Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body,
        icon: '/Gob_fitness_app_logo_Text_Fitness_Journey_colors_pastel_lilac_52f8c9f9-4435-4d8e-9799-dcdc1e07cad5_2.png',
        badge: '/Gob_fitness_app_logo_Text_Fitness_Journey_colors_pastel_lilac_52f8c9f9-4435-4d8e-9799-dcdc1e07cad5_2.png',
        tag: 'dulce-reminder',
        requireInteraction: false,
        ...options
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    }
  }

  static scheduleRecurringReminder(task) {
    // TODO: Implement recurring reminders with service worker
    console.log('Recurring reminders coming soon');
  }
}
